import { Button } from '@gravity-ui/uikit';
import { useLazyDownloadMkfPrefixMentionsReportQuery } from 'store/api';
import styles from './styles.module.scss';
import { useMkfPrefixDataQuery } from 'store/api/private/charts-api/chart-api-data';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';
import { ChartOptions } from 'chart.js/auto';
import ChartDataLabels from 'chartjs-plugin-datalabels';

export const MkfPrefixMentionsReport = () => {
	const [trigger, { isFetching }] = useLazyDownloadMkfPrefixMentionsReportQuery();

	const {
		data: mkfPrefixData,
		isLoading,
		error,
	} = useMkfPrefixDataQuery(null, {
		refetchOnMountOrArgChange: true,
		refetchOnFocus: true,
		refetchOnReconnect: true,
	});

	const chartData = {
		labels: mkfPrefixData?.map((d) => (d.mkfPrefix === '' ? 'Нет префикса' : d.mkfPrefix)),
		datasets: [
			{
				label: 'Количество упоминаний',
				data: mkfPrefixData?.map((d) => d.totalPatients),
				backgroundColor: ['#7ca7aeff', '#e4a786ff', '#f0a6a7ff', '#7c595aff', '#a7c4d4ff'],
				borderWidth: 1,
			},
		],
	};

	const options: ChartOptions<'pie'> = {
		responsive: true,
		plugins: {
			legend: { position: 'bottom' as const },
			datalabels: {
				color: '#fff',
				font: { weight: 'bold', size: 12 },
				anchor: 'center',
				align: 'center',
				clamp: true,
				formatter: (value: number, ctx: any) => {
					const label = ctx.chart.data.labels?.[ctx.dataIndex] ?? '';
					return ` ${value}`;
				},
			},
			// tooltip: { callbacks: { label: (ctx: any) => `${ctx.label}: ${ctx.parsed} чел.` } },
		},
	};

	const handleDownload = async () => {
		try {
			const result = await trigger().unwrap();
			const url = window.URL.createObjectURL(result);
			const link = document.createElement('a');
			link.href = url;
			link.setAttribute('download', 'Отчёт по МКФ-префиксам.xlsx');
			document.body.appendChild(link);
			link.click();
			link.remove();
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error('Ошибка при скачивании файла:', error);
		}
	};
	return (
		<div className={styles.chart}>
			<h2>Данные по МКФ-префиксам</h2>
			<div style={{ width: '100%', maxHeight: 700, display: 'flex', justifyContent: 'center' }}>
				<Pie data={chartData} options={options} plugins={[ChartDataLabels as any]} />
			</div>

			<Button onClick={handleDownload} loading={isFetching} size="xl">
				{isFetching ? 'Скачивание...' : 'Скачать отчёт по МКФ-префиксам'}
			</Button>
		</div>
	);
};
